import React, { ReactElement } from "react";

interface Pill {
  text: string,
  className?: string,
}

const Pill: React.FC<Pill> = ({ text, className }): ReactElement => (
    <div className={`font-ibmPlexSansSemiBold text-mobile-caption md:text-desktop-caption rounded-[50px] 
        px-4 py-[0.5rem] inline-block text-center bg-vibrant-green text-white ${className}`}>{text}
    </div>
);

export default Pill;
